import React, { useState } from 'react';
import { MenuItem } from '@mui/material';
import ListImportPopover from './ListImportPopover';
import { useTranslation } from 'react-i18next';
export var ListImportMenuItem = function (_a) {
    var listTitle = _a.listTitle, onImport = _a.onImport, onClose = _a.onClose, partialImportOnly = _a.partialImportOnly;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(MenuItem, { onClick: function (e) { return setAnchorEl(e.currentTarget); } }, t('listImport.import')),
        anchorEl && React.createElement(ListImportPopover, { listTitle: listTitle, anchorEl: anchorEl, onClose: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                setAnchorEl(null);
                onClose.apply(void 0, args);
            }, onImport: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                setAnchorEl(null);
                onImport.apply(void 0, args);
            }, partialImportOnly: partialImportOnly })));
};
export default ListImportMenuItem;
//# sourceMappingURL=ListImportMenuItem.js.map